import React from "react";

const Footer = () => (
    <footer>
        © {(new Date()).getFullYear()} Designed & Built by Kevin Bruccoleri
    </footer>
);

export default Footer;